import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_65: DocMigration = {
  maxSchemaVersion: "0.0.65",
  description: "Convert edge foundationInfo to edge footingPatterns",
  apply(json: any) {
    if (json.roomLayouts) {
      for (const layoutId in json.roomLayouts) {
        const roomLayout = json.roomLayouts[layoutId];
        if (roomLayout.foundationInfo) {
          if (!roomLayout.foundationInfo.length) {
            delete roomLayout["foundationInfo"];
            roomLayout["footingPatterns"] = [];
          } else {
            const edgePatternCount = {};

            const footingPatterns = roomLayout.foundationInfo.map((fi) => {
              const {
                edgeId,
                info: { footingType },
              } = fi;
              let edgeCount = +edgePatternCount[edgeId];
              edgePatternCount[edgeId] = ++edgeCount;
              const name = edgeCount > 1 ? `Footing Pattern ${edgeCount}` : "Footing Pattern";
              return {
                name,
                edgeId,
                footingPattern: {
                  footingType,
                },
              };
            });
            delete roomLayout["foundationInfo"];
            roomLayout["footingPatterns"] = footingPatterns;
          }
        }
      }
    }
    return json;
  },
};

export default migration_0_0_65;
